import { useAccountTrialInfo } from '@hotjar/account';
import { isOnActiveOrEligibleTrial } from '@hotjar/subscription-management';
import { useFeatureFlag } from '@hotjar/feature-flags';
import { isSiteOnScaleOrScaleTrial } from '@hotjar/recordings/src/utils/isSiteOnScaleOrScaleTrial';
import { ERROR_REPORTING as ERROR_REPORTING_FF } from '@hotjar/recordings/src/constants/feature-flags';
import type { Site } from '@hotjar/site';

type ErrorOccuredWidget = {
  isErrorCapturingFFEnabled: boolean;
  planAllowsErrorCapturing: boolean;
};

export const useErrorOccurredWidgetVisible = (site: Site): ErrorOccuredWidget => {
  const isErrorCapturingFFEnabled = useFeatureFlag(ERROR_REPORTING_FF);
  const trialInfo = useAccountTrialInfo();
  const isScaleOrScaleTrial =
    (trialInfo || undefined) &&
    isSiteOnScaleOrScaleTrial({ ...site, trial: { active: isOnActiveOrEligibleTrial(trialInfo) } });

  return { isErrorCapturingFFEnabled, planAllowsErrorCapturing: Boolean(isScaleOrScaleTrial) };
};
